import {Component, Injector, OnInit} from '@angular/core';
import {GoogleAnalyticsService} from '../../core/services/google-analytics.service';
import {Router} from '@angular/router';
import {openClose} from '../../animations';
import {BaseComponents} from '../base-components';
import {Meta, Title} from '@angular/platform-browser';
import {DeviceDetectorService} from 'ngx-device-detector';
import {HOME} from '../../app.constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass'],
  animations: [openClose]
})
export class HeaderComponent extends BaseComponents implements OnInit {
  isOpenFloatMenu = false;
  propostaUrls = [
    '/faca-parte',
    '/faca-parte-2',
    '/faca-parte-mobile',
    '/login',
    '/exclusividade',
    '/pagamentos',
    '/pagamento-credito',
    '/pagamento-debito',
    '/seguranca',
    '/confirmacao',
    '/confirmacao-compra',
    '/proposta-analise',
    '/pagamento-boleto',
    '/dados-pessoais',
    '/faca-parte-obrigado'
  ];
  salesUrls = [
    '/confirmacao-sales',
  ];
  landingUrl = ['/clube-montreal-de-hospedagem'];

  constructor(
      protected injector: Injector,
      protected titleService: Title,
      protected meta: Meta,
      private service: GoogleAnalyticsService,
      protected deviceService: DeviceDetectorService,
      protected router: Router) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    console.log('innerWidth => ', this.innerWidth);
    this.checkDevice();
  }

  toggleNavbar() {
    this.isOpenFloatMenu = !this.isOpenFloatMenu;
  }

  isPropostasMenu() {
    return this.propostaUrls.indexOf(this.router.url) > -1;
  }

  isPropostaSales() {
    return this.salesUrls.indexOf(this.router.url) > -1;
  }

  isLandingMenu() {
    return this.landingUrl.indexOf(this.router.url) > -1;
  }

  showSearchHeader() {
    return this.innerWidth < 2016;
  }

  blogLaunch() {
    const now = new Date();
    const day = new Date(2022, 4, 11, 18, 10);
    return now > day;

  }

    async redirectHome() {
      if (this.isIphone) {
        window.location.href = `${HOME}/`;
        return;
      }
      await this.router.navigate(['/']);
    }

  private checkDevice() {
    const deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    const { os = '' , device = ''} = deviceInfo;
    this.isIphone = device === 'iPhone' && os === 'iOS';
  }
}
